export function toJSON() {
  return this.r;
}
